interface ITimer {
    getDurationInWholeSeconds: () => string
}

export function Logg_timer(): ITimer {
    if (window.performance == null) {
        return { getDurationInWholeSeconds: () => '0' }
    }

    const startTime = performance.now()
    return {
        // We only to want to log to the nearest second
        // so that we can group metrics to give us a rough
        // feel of the time
        getDurationInWholeSeconds: () => Math.round((performance.now() - startTime) / 1000).toString(),
    }
}
